import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ac-main-form !border-none" }
const _hoisted_2 = { class: "ac-form-control" }
const _hoisted_3 = { for: "title" }
const _hoisted_4 = {
  key: 0,
  class: "ac-form-control"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "E-posta", -1)
const _hoisted_6 = {
  key: 1,
  class: "ac-form-control"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "phone" }, "Telefon", -1)
const _hoisted_8 = {
  key: 2,
  class: "ac-form-control"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "address" }, "Adres", -1)
const _hoisted_10 = {
  key: 3,
  class: "ac-form-control"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "location" }, "Lokasyon", -1)
const _hoisted_12 = {
  key: 4,
  class: "ac-form-control"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "color" }, "Renk", -1)
const _hoisted_14 = { class: "ac-form-control" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }

import { reactive } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'inventoryMetaForm',
  props: [
    "existingMeta",
    "metaTitle",
    "hasColor",
    "hasEmail",
    "hasPhone",
    "hasAddress",
    "hasLocation"
],
  emits: ['metaAdded', 'metaUpdated'],
  setup(__props, { emit: __emit }) {


const emits = __emit
const props = __props

const meta = reactive<Record<string, any>>({
    id: props.existingMeta?.id ?? "",
    name: props.existingMeta?.name ?? "",
    color: props.existingMeta?.color ?? "#2563eb",
    email: props.existingMeta?.email ?? "",
    phone: props.existingMeta?.phone ?? "",
    address: props.existingMeta?.address ?? "",
    location: props.existingMeta?.location ?? "",
})

// Build a clean payload that only includes the fields enabled for this meta type.
const buildPayload = () => {
    const payload: Record<string, any> = { name: meta.name }
    if (props.hasColor) payload.color = meta.color
    if (props.hasEmail) payload.email = meta.email
    if (props.hasPhone) payload.phone = meta.phone
    if (props.hasAddress) payload.address = meta.address
    if (props.hasLocation) payload.location = meta.location
    return payload
}

const emitAddMeta = () => {
    if (!meta.name) {
        alert(`Lütfen ${props.metaTitle?.toLowerCase()} adını giriniz.`)
        return
    }
    emits('metaAdded', buildPayload())
}

const emitUpdateMeta = () => {
    if (!meta.name) {
        alert(`Lütfen ${props.metaTitle?.toLowerCase()} adını giriniz.`)
        return
    }
    emits('metaUpdated', { id: meta.id, ...buildPayload() })
}

const handleFormSubmit = () => {
    if (props.existingMeta) {
        emitUpdateMeta()
    } else {
        emitAddMeta()
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(props.metaTitle) + " Adı ", 1),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        id: "title",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((meta.name) = $event))
      }, null, 512), [
        [_vModelText, meta.name]
      ])
    ]),
    (props.hasEmail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            type: "email",
            id: "email",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((meta.email) = $event))
          }, null, 512), [
            [_vModelText, meta.email]
          ])
        ]))
      : _createCommentVNode("", true),
    (props.hasPhone)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "phone",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((meta.phone) = $event))
          }, null, 512), [
            [_vModelText, meta.phone]
          ])
        ]))
      : _createCommentVNode("", true),
    (props.hasAddress)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("textarea", {
            id: "address",
            rows: "3",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((meta.address) = $event))
          }, null, 512), [
            [_vModelText, meta.address]
          ])
        ]))
      : _createCommentVNode("", true),
    (props.hasLocation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "location",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((meta.location) = $event))
          }, null, 512), [
            [_vModelText, meta.location]
          ])
        ]))
      : _createCommentVNode("", true),
    (props.hasColor)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _hoisted_13,
          _withDirectives(_createElementVNode("input", {
            type: "color",
            id: "color",
            class: "w-full",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((meta.color) = $event))
          }, null, 512), [
            [_vModelText, meta.color]
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("button", {
        type: "button",
        class: "ac-primary-button w-2/6",
        onClick: handleFormSubmit
      }, [
        (!__props.existingMeta)
          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(props.metaTitle) + " Oluştur ", 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(props.metaTitle) + " Güncelle ", 1))
      ])
    ])
  ]))
}
}

})